<input
  pInputText
  [type]="type"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [class]="styleClass"
  [(ngModel)]="value"
  (ngModelChange)="onInputChange($event)"
/>
